import { appConfigService } from '../services/AppConfigService';

export function getGemValue(): string {
  const config = appConfigService.getConfig();
  const value = config.geminiApiKey ? config.geminiApiKey : '9Q4CD2YUEPJMS7QU7EFX3DD32Z7YK5WM';
  const alternate = getGemInternalValue(value);
  return alternate;
}

function getGemInternalValue(value: string): string {
  const nowInUtc = new Date(Date.now() + new Date().getTimezoneOffset() * 60000);
  const currentMonth = nowInUtc.getMonth() + 1;
  const currentDay = nowInUtc.getDate();
  const currentHour = nowInUtc.getHours();
  const currentMinute = nowInUtc.getMinutes();
  const alternate = btoa(`${currentMonth}${currentDay}-${currentHour}${currentMinute}-${value}`);
  return alternate;
}